(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("embed-pdfjs-dist/web/pdf_viewer", [], factory);
	else if(typeof exports === 'object')
		exports["embed-pdfjs-dist/web/pdf_viewer"] = factory();
	else
		root["embed-pdfjs-dist/web/pdf_viewer"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition